import React from 'react';

import { ElementName, IconType } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseBadgeElement, type BaseBadgeElementProps, toBadgeProps } from '../common';

export type CommentCountElementProps = BaseBadgeElementProps;

const CommentCountElement = (props: CommentCountElementProps): JSX.Element | null => {
	const context = useFlexibleUiContext();
	const data = context ? toBadgeProps(context.commentCount?.toString()) : null;

	return data ? (
		<BaseBadgeElement
			icon={IconType.Comment}
			{...data}
			{...props}
			name={ElementName.CommentCount}
		/>
	) : null;
};

export default CommentCountElement;
